export default "__VITE_ASSET__DTkX1sHO__"